import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import get from 'lodash.get';

import { CreatorsTopCreator } from './CreatorsTopCreator';

import styles from './styles/CreatorsTopCreators.scss';

function CreatorsTopCreatorsComponent({ viewer, vertical }) {
    const title = get(viewer, 'topCreators.title');
    return (
        <div>
            <h2 className={styles.title} data-tn="top-creators-title">
                {title}
            </h2>
            <ul className={styles.listWrapper}>
                {(get(viewer, 'topCreators.creators') || []).map((topCreator, index) => (
                    <CreatorsTopCreator
                        key={topCreator.url}
                        position={index + 1}
                        topCreator={topCreator}
                        vertical={vertical}
                    />
                ))}
            </ul>
        </div>
    );
}

CreatorsTopCreatorsComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    vertical: PropTypes.string.isRequired,
};

export const CreatorsTopCreators = createFragmentContainer(CreatorsTopCreatorsComponent, {
    viewer: graphql`
        fragment CreatorsTopCreators_viewer on Viewer {
            topCreators(vertical: $vertical) {
                title
                creators {
                    url
                    ...CreatorsTopCreator_topCreator
                }
            }
        }
    `,
});
